import React, { FC, ReactNode } from "react";

import { NoContentMessage } from "~/components/atoms";
import { Loading } from "~/components/molecules";
import { NoDataDisplay } from "~/components/organisms";

type PropsType = {
  // eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents
  data?: null | Array<unknown> | unknown;
  loading: boolean;
  noContent: {
    message?: string;
    type: "inline" | "block";
  };
  error: string | null;
  children: ReactNode;
};

export const Fetch: FC<PropsType> = ({
  data,
  loading,
  noContent,
  error,
  children,
}: PropsType) => {
  const hasContent = Array.isArray(data) ? data.length : data;

  if (loading) return <Loading className="mt-8" />;
  if (error) return <pre>{error}</pre>;
  if (!hasContent)
    return noContent.type === "inline" ? (
      <NoContentMessage text={noContent.message || "データがありません"} />
    ) : (
      <NoDataDisplay message={noContent.message} />
    );

  return <>{children}</>;
};
